import Vue from 'vue';
import Vuex from 'vuex';
import { IUserState } from './modules/user';
import { IMenuState } from './modules/menu';

Vue.use(Vuex);

export interface IRootState {
  user: IUserState
  menu: IMenuState
}

export default new Vuex.Store<IRootState>({});
